import { Field, connect } from 'formik'
import React, { useEffect, useMemo, useState } from 'react'
import usePromise from 'react-use/lib/usePromise' // TODO: revert import change when this issue is resolved: https://github.com/streamich/react-use/issues/2074
import {
  LangCounts,
  LangRadioOuterProps,
  NewsletterRecipientsSelectionFormValues,
  NewsletterRecipientsSelectionOuterProps,
  SubscriptionOptionList,
} from './types'
import { FormGroup, JSONFetcher, handleError } from 'src/shared'

export const NewsletterRecipientsSelection: React.ComponentType<NewsletterRecipientsSelectionOuterProps> = connect<
  NewsletterRecipientsSelectionOuterProps,
  NewsletterRecipientsSelectionFormValues
>(({ formik, ...props }) => {
  const mounted = usePromise()
  const [langCounts, setLangCounts] = useState<LangCounts | undefined>()
  const [langSelectionDisabled, setLangSelectionDisabled] = useState(false)

  const project_options = useMemo(() => {
    if (!props.projectSubscriptionOptions) return
    const data: SubscriptionOptionList = JSON.parse(props.projectSubscriptionOptions)
    return data.map(([label, value]) => (
      <option value={value} key={value}>
        {label}
      </option>
    ))
  }, [props.projectSubscriptionOptions])

  useEffect(() => {
    const fn = async () => {
      const data = formik.values._owner_id
        ? props.langCounts
        : (await mounted(
            JSONFetcher.call<unknown, LangCounts | null | undefined>({
              url: props.apiBaseUrl + `?project_id=${formik.values.project_id || ''}`,
            })
          )) || undefined
      setLangCounts(data ?? undefined)
      let disabled = true
      if (data) {
        const lang = (data['de'] && 'de') || (data['en'] && 'en') || ''
        disabled = !!lang && !(data['de'] && data['en']) // disable when only one option is valid
        void formik.setFieldValue('lang', lang)
      }
      setLangSelectionDisabled(disabled)
    }
    fn().catch((error) => handleError(error))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.project_id])

  return (
    <>
      {project_options && (
        <Field
          name={formik.values.owner_id ? 'owner_id' : 'project_id'}
          label={i18n.t('manage.newsletter_recipients_selection.project_label')}
          component={FormGroup}
          required
        >
          <select
            className="form-control select"
            name={formik.values.owner_id ? 'owner_id' : 'project_id'}
            id={formik.values.owner_id ? 'owner_id' : 'project_id'}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.project_id}
          >
            {project_options}
          </select>
        </Field>
      )}

      <fieldset className="form-group">
        <legend className="col-form-label pt-0">
          <span>{i18n.t('manage.newsletter_recipients_selection.lang_label')}</span>{' '}
          <abbr title={i18n.t('misc.required_field')}>*</abbr>
        </legend>
        <LangRadio option="total" value="" langCounts={langCounts} langSelectionDisabled={langSelectionDisabled} />
        <LangRadio option="de" value="de" langCounts={langCounts} langSelectionDisabled={langSelectionDisabled} />
        <LangRadio option="en" value="en" langCounts={langCounts} langSelectionDisabled={langSelectionDisabled} />
      </fieldset>
    </>
  )
})

// TODO check what is this disabled on the label doing as it is not a valid HTML attribute in this context

const LangRadio = connect<LangRadioOuterProps, NewsletterRecipientsSelectionFormValues>(
  ({ formik, option, value, langCounts, langSelectionDisabled }) => (
    <div className="form-check">
      <Field
        type="radio"
        name="lang"
        id={`lang_${option}`}
        value={value}
        className="form-check-input"
        disabled={langSelectionDisabled && formik.values.lang !== value}
      />
      <label
        className="form-check-label"
        htmlFor={`lang_${option}`}
        // disabled={langSelectionDisabled && formik.values.lang !== value}
      >
        {i18n.t(`manage.newsletter_recipients_selection.lang_option_${option}`)}
        {langCounts &&
          i18n.t(`manage.newsletter_recipients_selection.count_description`, {
            count: langCounts[option],
          })}
      </label>
    </div>
  )
)
